import {SETTING} from '../types';

export const initialState = {
    setting:[]
};

export default (state = initialState, action) => {
    console.log(action.payload)
    switch (action.type) {
        case SETTING:
            return {
                ...state,
                setting: action.payload,
            };
        default:
            return state;
    }
}
